// extracted by mini-css-extract-plugin
export default {"formContainer":"addNewHabbit_formContainer__0DN6v","form":"addNewHabbit_form__Ux3NK","inputFiled":"addNewHabbit_inputFiled__UlpbD","submitBtn":"addNewHabbit_submitBtn__UF0aC"};